// src/constants/menuTranslationKeys.ts

export const MENU_TRANSLATION_KEYS = {
  // Main Menu Items
  ADVERTISEMENTS: 1022,
  PARTNER_COMPANIES: 1023,
  CHAT: 1024,
  EVENTS: 1025,
  PERSONAL_PROFILE: 1026,
  COMPANY_PROFILE: 1027,

  // Advertisement Submenu
  ALL_ADVERTISEMENTS: 1028,
  NEW_ADVERTISEMENTS:1121,
  RECEIVED_OFFERS: 1029,
  BOOSTED_TO_ME: 1030,
  ADVERTISEMENT_MANAGEMENT: 1031,
  MY_RELATED_ADVERTISEMENTS: 1032,
  RECEIVED_PRICES: 1033,
  SENT_BOOSTS: 1034,

  // Partner Companies Submenu
  PARTNER_COMPANIES_LIST: 1035,
  CORPORATE_INVITATIONS: 1036,

  // Personal Profile Submenu
  PERSONAL_INFORMATION: 1037,
  CHANGE_PASSWORD: 1038,
  RECEIVED_INVITATIONS: 1039,

  // Company Profile Submenu
  COMPANY_MAIN_INFO: 1040,
  STAFF_INVITATIONS: 1041,
  ORGANIZATIONAL_CHART: 1042,
  COMPANY_ADDRESSES: 1043,
  COMPANY_CATEGORIES: 1044,
  COMPANY_EVALUATION_PROFILE: 1045,
} as const;

export type MenuTranslationKey =
  (typeof MENU_TRANSLATION_KEYS)[keyof typeof MENU_TRANSLATION_KEYS];
